import type { Capacity } from '@/features/execute-calculation-set/overmind/calculation/domain/Capacity';
import type { Amperes } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';

import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { EvaluatedResult } from '../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForAcLineSegmentEvaluation } from '../../../gridElements/acLineSegment/forAcLineSegmentEvaluation';
import { AvailableCapacityEvaluation } from './propertiesEvaluation/AvailableCapacityEvaluation';
import { CurrentEvaluation } from './propertiesEvaluation/CurrentEvaluation';
import { LoadingPercentEvaluation } from './propertiesEvaluation/loadingPercent';

export class AcLineSegmentEvaluationEngine
  implements ForAcLineSegmentEvaluation
{
  constructor(private readonly ruleProvider: ForRuleProviding) {}
  evaluateCurrent(
    current: number,
    messenger: ForMessaging<AttentionStatusType>
  ) {
    const evaluation = new CurrentEvaluation(this.ruleProvider).evaluate(
      current
    );
    messenger.send(evaluation.status, this.evaluateCurrent.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateAvailableCapacity(
    capacity: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Amperes> {
    const evaluation = new AvailableCapacityEvaluation(
      this.ruleProvider
    ).evaluate(capacity);
    messenger.send(evaluation.status, this.evaluateAvailableCapacity.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateLoadingPercent(
    voltage: number,
    messenger: ForMessaging<AttentionStatusType>
  ) {
    const evaluation = new LoadingPercentEvaluation(this.ruleProvider).evaluate(
      voltage
    );
    messenger.send(evaluation.status, this.evaluateLoadingPercent.name);
    return evaluation.toEvaluatedResult();
  }
}
